<div id="login-wrapper" class="container-fluid h-100">
  <div id="login-content" class="row align-items-center justify-content-center">
    <div class="col-lg-auto">
      <div id="brand">
        <img id="seos-logo" [src]="'assets/images/seos_logo.png'">
        <img id="seos-text" [src]="'assets/images/seos_text.png'">
        <div id="seos-long-text">smart education operating system</div>
      </div>
    </div>
    <div class="col-lg-auto d-none d-lg-block">
      <div id="divider"></div>
    </div>
    <div class="col-lg-5 col-xl-4">
      <div id="login-form-wrapper" class="col p-4">
        <div class="title">{{ loginAsLabel | translate }}</div>

        <form #loginForm="ngForm" class="p-2" (ngSubmit)="onSubmit(loginRequest)" method="post" novalidate>
          <div id="username-group" class="form-floating mb-3 row">
            <input id="username" type="email" name="username" class="form-control require-border-none"
                   inputmode="email"
                   #username="ngModel"
                   [placeholder]="'LOGIN.EMAIL' | translate"
                   [(ngModel)]="loginRequest.username"
                   [ngClass]="{ 'is-invalid': !username.valid && !username.pristine }" autofocus email required>
            <label for="username">{{ 'LOGIN.EMAIL' | translate }}</label>
          </div>
          <div id="password-group" class="form-floating mb-3 row">
            <input id="password" type="password" name="password" class="form-control require-border-none"
                   #password="ngModel"
                   [placeholder]="'LOGIN.PASSWORD' | translate"
                   [(ngModel)]="loginRequest.password"
                   [ngClass]="{ 'is-invalid': !password.valid && !password.pristine }" required>
            <label for="password">{{ 'LOGIN.PASSWORD' | translate }}</label>
          </div>
          <div class="row">
            <button type="submit" class="btn btn-lg btn-primary w-100" [disabled]="loginForm.invalid">
              {{ 'LOGIN.LOGIN_BTN' | translate }}
            </button>
          </div>
        </form>
        <div id="login-with-google" role="button"
             class="border-top border-secondary mt-4 pt-4 d-flex justify-content-center">
          <div id="g_id_onload"
               [attr.data-client_id]="getWebAppClientId()"
               data-callback="handleCredentialResponse">
          </div>
          <div class="g_id_signin" data-type="standard" data-theme="filled_blue"></div>
          <!--              <div class="g_id_signin" data-type="standard" data-theme="filled_blue" data-locale="hu_HU"></div>-->
          <!--              <asl-google-signin-button></asl-google-signin-button>-->
        </div>
        <div id="login-as-student-link" class="border-top border-secondary mt-4 pt-4 text-center">
          <a href="/student/login" class="fw-bold text-info">{{ 'LOGIN.LOGIN_AS_STUDENT' | translate }}</a>
        </div>
        <div id="privacy-policy-link" class="text-center m-2">
          <a target="_blank" href="https://www.seos.app/privacy" class="privacy-policy"><small>Privacy Policy</small></a>
        </div>
      </div>
    </div>
  </div>
</div>
